export const getDifferenceByProperty = (newList: any[], oldList: any[], property = 'id'): any[] => {
  const oldSet = new Set(oldList.map(item => item[property]))
  return newList.filter(item => !oldSet.has(item[property]))
}
